
export type DictionaryFormValues = {
  key: string
  value: string
  group: string
}

export const defaultDictionaryFormValues: DictionaryFormValues = {
  key: '',
  value: '',
  group: ''
}